let dt = require('dateformat');
dt.i18n = {
    dayNames: [
        "Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", 
        "domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado" 
    ],
    monthNames: [
      "Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic",
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ],
    timeNames: [
        'a', 'p', 'am', 'pm', 'A', 'P', 'AM', 'PM'
    ]
  };

export const func = {
  isMobile: () => {
    if( screen.width <= 760 ) { // BASADO EN EL TAMAÑO DE La PANTALLA
      return true;
    }
    else {
      return false;
    }
    // if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    //   return true
    // } else {
    //   return false
    // }
  },
  returnID: (s) => {
     let _t = s.split('').reduce((a,b) => (((a << 5) - a) + b.charCodeAt(0))|0, 0);
     if( _t < 1)
      _t = (_t * -1)
     return _t;
   },
   getDateFormat: ($d,$f,$tf) => {
    let f = "";
    if($d == null )
      return;
    let now = new Date($d);
    if( $tf == null || $tf == undefined )
      f = ($f == "D") ? dt(now, "dd/mm/yyyy"): dt(now, "h:MM TT") ;
    else
      f = ($f == "D") ? dt(now, $tf): dt(now, "h:MM TT") ;
    return f;
  }
}